import styled from "styled-components";

const NotesSection = styled.div`
  height: calc(100dvh - 265px);
  border-radius: 4px;
  display: flex;
`;

export default NotesSection;
